<!-- Slideshow.svelte -->
<script>
  let currentIndex = 0;
  export let images = [];

  function nextSlide() {
    currentIndex = (currentIndex + 1) % images.length;
  }

  function previousSlide() {
    currentIndex = (currentIndex - 1 + images.length) % images.length;
  }
</script>

<div class="slideshow">
  <button class="prevbtn" on:click={previousSlide}>{@html "<"}</button>
  <img src={images[currentIndex]} alt="Slideshow" />
  <button class="nextbtn" on:click={nextSlide}>{@html ">"}</button>
</div>

<style>
  .slideshow {
    position: relative;
    width: 100%;
    height: auto;
    margin: auto;
  }
  .slideshow img {
    width: 100%;
    margin: auto;
  }
  .nextbtn {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
    top: 50%;
    right: 0;
    bottom: 0;
    left: 90;
    width: 5%;
    height: 5%;
    background-color: rgba(255, 255, 255, 0.577);
    border-width: 0;
    font-size: 50px;
    padding: 50px;
    cursor: pointer;
  }
  .nextbtn:hover{
    background-color: antiquewhite;
  }
  .prevbtn {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
    top: 50%;
    right: 0;
    bottom: 0;
    left: 0;
    width: 5%;
    height: 5%;
    background-color: rgba(255, 255, 255, 0.577);
    border-width: 0;
    font-size: 50px;
    padding: 50px;
    vertical-align: middle;
    cursor: pointer;
  }
  .prevbtn:hover{
    background-color: antiquewhite;
  }

  @media screen and (max-width: 800px) {
  .prevbtn{
    padding: 7%;
  }
  .nextbtn{
    padding: 7%;
  }
  
  
  }
</style>
